import { render, staticRenderFns } from "./ReportTabs.vue?vue&type=template&id=2d8d5cec&scoped=true"
import script from "./ReportTabs.vue?vue&type=script&lang=js"
export * from "./ReportTabs.vue?vue&type=script&lang=js"
import style0 from "./ReportTabs.vue?vue&type=style&index=0&id=2d8d5cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d5cec",
  null
  
)

export default component.exports